import domready from 'domready';
import init from './handler';

domready(init);
